import React from "react";
import { Link } from "react-router-dom";
import "./LpEmbassy.css";
import bahrain from "../../../vid_img/Countries_Flag/Baharain.png";
import malaysia from "../../../vid_img/Countries_Flag/Malaysia.png";
import qatar from "../../../vid_img/Countries_Flag/Qatar.png";
import saudi from "../../../vid_img/Countries_Flag/Saudi Arabia.png";
import uae from "../../../vid_img/Countries_Flag/UAE.png";
import kuwait from "../../../vid_img/Countries_Flag/Kuwait.png";

const embassies = [
  {
    flag: malaysia,
    name: "MALAYSIA",
    alt: "malaysia",
    link: "/mea-attestation-apostille-services",
  },
  {
    flag: uae,
    name: "UAE",
    alt: "uaeEmbassy",
    link: "/uae-embassy-attestation-bangalore",
  },
  {
    flag: qatar,
    name: "QATAR",
    alt: "qatarEmbassy",
    link: "/qatar-embassy-attestation-bangalore",
  },
  {
    flag: kuwait,
    name: "KUWAIT",
    alt: "kuwaitEmbassy",
    link: "/kuwait-embassy-attestation-bangalore",
  },
  {
    flag: bahrain,
    name: "BAHRAIN",
    alt: "bahrainEmbassy",
    link: "/bahrain-embassy-attestation-bangalore",
  },
  {
    flag: saudi,
    name: "SAUDI",
    alt: "saudiEmbassy",
    link: "/saudi-embassy-attestation-bangalore",
  },
];

const LpEmbassyMain = () => {
  return (
    <div className="lpEmbassyMain-container">
      {embassies.map((embassy, index) => (
        <div className="lpEmbassyMain-content" key={index}>
          <img src={embassy.flag} alt={embassy.alt} loading="lazy" />
          <div className="lpEmbassyMain-overlay">
            <h3>
              <Link to={embassy.link}>{embassy.name}</Link>
            </h3>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LpEmbassyMain;
